module.exports = __webpack_public_path__ + "img/emoji_16.0053937c.png";